import moment from 'moment-timezone';
import { SCHEDULE_SPECIFIC } from './auctionFormConstants';

/** YYYY-MM-DD from string or Date-like value from v-date-picker */
export function normalizeDateIso(dateIso) {
  if (dateIso == null || dateIso === '') return '';
  if (typeof dateIso === 'string') {
    if (dateIso.length >= 10 && dateIso[4] === '-' && dateIso[7] === '-') {
      return dateIso.slice(0, 10);
    }
  }
  const m = moment(dateIso);
  return m.isValid() ? m.format('YYYY-MM-DD') : '';
}

/**
 * Single label for v-select when "Specific time" is chosen (uses ISO date + time string).
 */
export function formatScheduleSpecificLabel(dateIso, timeStr) {
  const iso = normalizeDateIso(dateIso);
  if (!iso || timeStr == null || timeStr === '') return '';
  const raw = String(timeStr).trim();
  if (!raw.includes(':')) return '';
  const seg = raw.split(':').filter((s) => s !== '');
  let normalized;
  if (seg.length === 2) {
    normalized = `${seg[0].padStart(2, '0')}:${seg[1].padStart(2, '0')}:00`;
  } else if (seg.length === 3) {
    normalized = `${seg[0].padStart(2, '0')}:${seg[1].padStart(2, '0')}:${seg[2].padStart(2, '0')}`;
  } else {
    return '';
  }
  const m = moment(`${iso}T${normalized}`, 'YYYY-MM-DDTHH:mm:ss', true);
  return m.isValid() ? m.format('DD-MM-YYYY HH:mm') : '';
}

export function formatDate(date) {
  if (!date) return null;
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}

export function parseDate(date) {
  if (!date) return null;
  const [day, month, year] = date.split('-');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

/** Parse YYYY-MM-DD + time string into a strict moment (same rules as schedule pickers). */
export function parseIsoAndTimeToMoment(dateIso, timeStr) {
  const iso = normalizeDateIso(dateIso);
  if (!iso || timeStr == null || timeStr === '') return null;
  const raw = String(timeStr).trim();
  if (!raw.includes(':')) return null;
  const seg = raw.split(':').filter((s) => s !== '');
  let normalized;
  if (seg.length === 2) {
    normalized = `${seg[0].padStart(2, '0')}:${seg[1].padStart(2, '0')}:00`;
  } else if (seg.length === 3) {
    normalized = `${seg[0].padStart(2, '0')}:${seg[1].padStart(2, '0')}:${seg[2].padStart(2, '0')}`;
  } else {
    return null;
  }
  const m = moment(`${iso}T${normalized}`, 'YYYY-MM-DDTHH:mm:ss', true);
  return m.isValid() ? m : null;
}

export function buildScheduleStartMoment(scheduleValue, dateIso, timeStr) {
  if (scheduleValue === SCHEDULE_SPECIFIC) {
    return parseIsoAndTimeToMoment(dateIso, timeStr);
  }
  if (typeof scheduleValue === 'number' && scheduleValue > 0) {
    const now = new Date();
    const startIso =
      moment(now).tz('Europe/Kiev').format('YYYY-MM-DD') +
      'T' +
      moment(now.getTime() + (scheduleValue + 5000))
        .tz('Europe/Kiev')
        .format('HH:mm:ss');
    return moment(startIso);
  }
  return null;
}

/** Clear field if user typed letters (legacy behaviour). */
export function shouldClearTimeField(value) {
  return Boolean(value && /[a-zа-я]/.test(String(value).toLowerCase()));
}
